/**
 * LengthRole - Classe OOP para manipulação de unidades de comprimento
 *
 * Implementa os 4 pilares via composição dos módulos separados.
 * Para uso funcional, importe diretamente dos pilares:
 *
 * @example
 * // OOP
 * import { lengthRole } from '@attrx/role-morphic/length';
 * lengthRole.convert('kilometer', 'mile', 1);
 *
 * // Funcional
 * import { convertLength } from '@attrx/role-morphic/length/convert';
 * convertLength('kilometer', 'mile', 1);
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { LENGTH_UNITS, LENGTH_ALIASES } from "./constants";

// =============================================================================
// LENGTH ROLE CLASS
// =============================================================================

export class LengthRole extends SimpleRole {
  readonly name = "length";
  readonly base = "meter";
  readonly units = LENGTH_UNITS;
  readonly aliases = LENGTH_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Length cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da LengthRole */
export const lengthRole = new LengthRole();
